class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code?.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    const closeBtn = this.querySelector('button[type="button"]');
    if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Kunci scroll pada root (html) agar stabil di iOS
    document.documentElement.classList.add('is-modal-open');

    // Trap focus & fokus input tanpa memicu scroll viewport
    const container = this.detailsContainer.querySelector('[tabindex="-1"]');
    const firstInput = this.detailsContainer.querySelector('input:not([type="hidden"])');

    if (typeof trapFocus === 'function') {
      trapFocus(container, firstInput);
    }

    if (firstInput && firstInput.focus) {
      try {
        firstInput.focus({ preventScroll: true });
      } catch {
        firstInput.focus();
      }
    }
  }

  close(focusToggle = true) {
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }

    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.documentElement.classList.remove('is-modal-open');
  }
}

customElements.define('details-modal', DetailsModal);